import { mockCards } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between mb-10 md:mb-14">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              精选推荐
            </h2>
            <p className="text-sm text-foreground-500">编辑团队每日精选高分漫画</p>
          </div>
          <span className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-600 font-medium cursor-pointer whitespace-nowrap">
            查看全部 <i className="ri-arrow-right-line"></i>
          </span>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-7 gap-4 md:gap-5">
          {mockCards.map((card, idx) => (
            <div
              key={idx}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[3/4] rounded-xl overflow-hidden bg-background-100 mb-3 border border-background-200/70 group-hover:border-primary-200 transition-all duration-300">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-2 left-2">
                  <span className="inline-block px-2 py-0.5 text-[10px] font-medium bg-background-50/90 text-primary-700 rounded whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
                <div className="absolute top-2 right-2">
                  <span className="inline-flex items-center gap-0.5 px-2 py-0.5 text-[10px] font-bold bg-accent-500 text-background-50 rounded whitespace-nowrap">
                    <i className="ri-fire-line text-[10px]"></i> {card.heat}
                  </span>
                </div>
                <div className="absolute bottom-2 right-2">
                  <span className={`inline-block px-2 py-0.5 text-[10px] font-medium rounded whitespace-nowrap ${
                    card.status === '连载中'
                      ? 'bg-accent-100 text-accent-700'
                      : 'bg-secondary-100 text-secondary-700'
                  }`}>
                    {card.status}
                  </span>
                </div>
              </div>
              <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 mb-1 truncate">
                {card.title}
              </h3>
              <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">
                {card.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}